import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  GetCuratorShopLinkServiceRequest,
  GetLinkCouponServiceRequest,
  GetLinkCurationServiceRequest,
} from '@musinsa/services-curator';
import {
  getCuratorShopLinkService,
  getLinkCouponService,
  getLinkCurationService,
} from '@musinsa/services-curator';

export const linkFactory = createQueryKeys('link', {
  getLinkCuration: (params: GetLinkCurationServiceRequest) => ({
    queryKey: [params.curationId, params],
    queryFn: () => getLinkCurationService(params),
  }),
  getLinkCoupon: (params: GetLinkCouponServiceRequest) => ({
    queryKey: [params.couponNo, params],
    queryFn: () => getLinkCouponService(params),
  }),
  getCuratorShopLink: (params: GetCuratorShopLinkServiceRequest) => ({
    queryKey: [params.snsTitle, params],
    queryFn: () => getCuratorShopLinkService(params),
  }),
});
